var renderLotto = function($container){
	
	$.ajax({
	      dataType: 'json',
	      url: 'https://www.lotto24.de/public/product-info/v2/drawinfo/draws?games=dbg.lotto.normal,dbg.eurojackpot',
	      success: function (data) {
	    	  ntvDebug("*** Lotto ajax ***");
	    	  ntvDebug(data);
	    	  render(data);
	      }
	});
	
	var render = function(data){

    if(!data.games) return;

    var actualDate = new Date();
    var cutoffDateLotto = new Date(data.games['dbg.lotto.normal'].draws[1].cutoffTimestamp);
    var cutoffDateEuro = new Date(data.games['dbg.eurojackpot'].draws[1].cutoffTimestamp);

    var lotto = [];
      // conditions eurojackpot show first
      if (
        !(
          (actualDate.getDay() == 2 &&
            !(cutoffDateEuro.getDay() == 2 && actualDate < cutoffDateEuro)) ||
          (actualDate.getDay() == 3 &&
            cutoffDateLotto.getDay() == 3 &&
            actualDate < cutoffDateLotto) ||
          (actualDate.getDay() == 5 &&
            !(cutoffDateEuro.getDay() == 5 && actualDate < cutoffDateEuro)) ||
          (actualDate.getDay() == 6 &&
            cutoffDateLotto.getDay() == 6 &&
            actualDate < cutoffDateLotto)
        )
      ) {
        lotto = [data.games['dbg.eurojackpot'], data.games['dbg.lotto.normal']];
      }else{
        lotto = [data.games['dbg.lotto.normal'], data.games['dbg.eurojackpot']];
      }

      $( $container ).each(function( index ) {
			
        var $thisContainer = $(this);
        var containerId = "lotto-" + index;
        var $slider = $(".lotto__slides", $thisContainer);
        
        $thisContainer.attr("id", containerId);
		
			  $( ".lotto__lottery", $thisContainer ).each(function( index ) {


          var $lottery = $(this);
          var lottery_data = lotto[index];

          var lastDraw = lottery_data.draws[0];
          var nextDraw = lottery_data.draws[1];

          var lottery_name = lastDraw.game==='dbg.lotto.normal'?'6aus49':'eurojackpot';
          var lastDrawDate = new Date(lastDraw.drawTimestamp);
          var lotteryKey = lottery_name==='6aus49'?'LOTTO_6_AUS_49':'EUROJACKPOT';

          var result = lastDraw.lotteries[lotteryKey].drawResult;
          var html_numbers = "";
          var jackpot = null;
          if(nextDraw.lotteries[lotteryKey].jackpot && nextDraw.lotteries[lotteryKey].jackpot.jackpots && nextDraw.lotteries[lotteryKey].jackpot.jackpots.WC_1){
            jackpot = nextDraw.lotteries[lotteryKey].jackpot.jackpots.WC_1.amountInMinor;
          }

          $lottery.addClass("lotto__lottery--" + lottery_name);
          $(".lotto__logo", $lottery).attr("src",resourceBaseUrl + "/adaptive/images/logo_" + lottery_name + ".png");
          
          if(jackpot){
            $(".lotto__jackpot__value", $lottery).html(jackpot/100000000 + " Mio. €");
          }else{
            $(".lotto__jackpot__value", $lottery).html("wird ermittelt");
            $(".lotto__jackpot__value", $lottery).addClass("lotto__jackpot__value--status");
          }
          
          
          $(".lotto__numbers span", $lottery).html("Gewinnzahlen vom " + lastDrawDate.getDate() + "." + (lastDrawDate.getMonth()+1) + "." + lastDrawDate.getFullYear());
          
          for (var i = 0; i < result.numbers.length; i++) {
					  html_numbers += '<li>' + result.numbers[i] + '</li>';
				  }
          if(lottery_name=='6aus49'){
					  html_numbers += '<li>' + result.superNumber + '</li>';
					  $(".lotto__jackpot__button", $lottery).attr("href", "https://lotto.n-tv.de/lotto-6-aus-49?partnerId=1NTCOO0001&advertisementId=1HOMEPA000HOWIDGLOTTOSTATIHT51000ZEITMIFRSA");
				  }
				  if(lottery_name=='eurojackpot'){
					  for (i = 0; i < result.euroNumbers.length; i++) {
						  html_numbers += '<li>' + result.euroNumbers[i] + '</li>';
						}
					  $(".lotto__jackpot__button", $lottery).attr("href", "https://lotto.n-tv.de/eurojackpot?partnerId=1NTCOO0001&advertisementId=1HOMEPA000HOWIDGEJPSTATISCHT52000ZEITDOFR00");
				  }
				
				  $(".lotto__numbers ul", $lottery).html(html_numbers);

          $thisContainer.removeClass("lotto--hide");

        });

        $slider.on('init', function(slick) {
				  $(".lotto__lottery", $thisContainer).removeClass("lotto__lottery--hidden");
			  });
			

        if( !$slider.hasClass( 'slick-initialized' ) ){
			   $slider.slick(
			     {
			    	    arrows     : false,
			    	 	appendArrows   : '[id="' + containerId + '"] .lotto__slider__controls',
			    	 	appendDots   : '[id="' + containerId + '"] .lotto__slider__controls',
			    	    dots       : true,
			    	    infinite   : false,
			    	    mobileFirst: true,
			            responsive   : [
			                {
			                  breakpoint: 767,
			                  settings  : {
			                    arrows   : true,
			                    nextArrow: '<button class="slick--next icon icon__next" aria-label="Next"></button>',
			                    prevArrow: '<button class="slick--prev icon icon__prev" aria-label="Previous"></button>'
			                  }
			                },
			                {
			                  breakpoint: 1279,
			                  settings  : {
			                    arrows   : true,
			                    nextArrow: '<button class="slick--next icon icon__next" aria-label="Next"></button>',
			                    prevArrow: '<button class="slick--prev icon icon__prev" aria-label="Previous"></button>',
			                    swipe: false
			                  }
			                }
			              ]
			     } );
			   }
        });
		};
};